import React, { useState, useMemo } from 'react'
import { DayPicker, Row } from 'react-day-picker'
import { ptBR } from 'date-fns/locale'
import { MONTHS } from 'src/utils'
import moment from 'moment'
import ChevronRight from 'static/icons/chevron-right.svg'
import ChevronLeft from 'static/icons/chevron-left.svg'
import * as S from './styles'

const Calendar = ({
  weekView = false,
  displayDate = moment(),
  onChangeDay,
  initialValue,
  disabledDays = [],
  onChangeCalendar,
  campaignDays,
  showOutsideDays = false
}) => {
  const [selectedDate, setSelectedDate] = useState(initialValue || undefined)
  const [currentWeek, setCurrentWeek] = useState(selectedDate || undefined)
  const dateFormatteDisplayDate = moment(displayDate).toDate()
  const dateFormattedSelectedDate = useMemo(() => {
    return selectedDate ? moment(selectedDate).toDate() : undefined
  })
  moment.locale('pt-BR')
  const now = moment().toDate()
  const dayPickerProps = {
    fromDate: now,
    mode: 'single',
    disabled: disabledDays,
    selected: dateFormattedSelectedDate,
    month: dateFormatteDisplayDate,
    locale: ptBR,
    disableNavigation: true,
    modifiers: { campaign: campaignDays },
    modifiersClassNames: { campaign: 'with-campaign' },
    formatters: { formatWeekdayName: (day) => moment(day).format('ddd') },
    showOutsideDays
  }

  const generateWeek = (start) => Array.from({ length: 7 }, (_, i) => moment(start).add(i, 'days'))
  const weekToRender = useMemo(() => {
    const startDate = moment(currentWeek).subtract(3, 'days')
    return generateWeek(startDate)?.map((weekDay) => weekDay.toDate())
  }, [displayDate, currentWeek])

  const weekViewLoaded = weekView && weekToRender.length > 0

  const renderWeekView = () => {
    const startOfWeek = moment(weekToRender[0])
    const endOfWeek = moment(weekToRender[6])

    const currentWeekRow = (props) => {
      const isDateInCurrentWeek = (dateToCheck) => moment(dateToCheck).isBetween(startOfWeek, endOfWeek)
      const isNotCurrentWeek = props.dates.every((date) => !isDateInCurrentWeek(date))
      if (isNotCurrentWeek) return <></>
      return <Row {...props} />
    }

    return (
      <>
        <DayPicker
          onSelect={(date) => {
            if (!date) return
            onChangeDay(date)
            setSelectedDate(date)
          }}
          weekStartsOn={startOfWeek.day()}
          components={{ Row: currentWeekRow }}
          {...dayPickerProps}
        />
      </>
    )
  }

  const handleChangeWeek = (operation) => {
    const OPERATIONS = {
      add: 7,
      subtract: -7
    }
    const newWeek = moment(currentWeek).add(OPERATIONS[operation], 'days')
    const isSameMonth = newWeek.isSame(currentWeek, 'month')

    setCurrentWeek(newWeek)
    return isSameMonth
  }

  return (
    <S.Wrapper>
      <S.CalendarStyles />
      <S.MonthHeader>
        <S.Navigation
          onClick={() => {
            if (weekView) {
              const isSameMonth = handleChangeWeek('subtract')
              if (isSameMonth) return
            }
            const operation = 'subtract'
            const view = 'months'
            onChangeCalendar(operation, view)
          }}
        >
          <ChevronLeft />
        </S.Navigation>
        <S.MonthTitle>{`${MONTHS[dateFormatteDisplayDate.getMonth()]} de ${moment(dateFormatteDisplayDate).locale('pt-BR').format('YYYY')}`}</S.MonthTitle>
        <S.Navigation onClick={(event) => {
          event.preventDefault()
          if (weekView) {
            const isSameMonth = handleChangeWeek('add')
            if (isSameMonth) return
          }
          const operation = 'add'
          const view = 'months'
          onChangeCalendar(operation, view)
        }}
        >
          <ChevronRight />
        </S.Navigation>
      </S.MonthHeader>
      {weekViewLoaded && renderWeekView()}
      {!weekView &&
        <DayPicker
          onSelect={(date) => {
            if (!date) return
            onChangeDay(date)
            setSelectedDate(date)
          }}
          {...dayPickerProps}
        />}
    </S.Wrapper>
  )
}

export default Calendar
